import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-main-acct',
  templateUrl: './main-acct.component.html',
  styleUrls: ['./main-acct.component.css']
})
export class MainAcctComponent implements OnInit {
  // private dp = [];
  // displayedColumns = ['main_acct_name', 'main_acct_number', 'edit', 'del'];
  // dataSource = new MatTableDataSource(this.dp);
  // @ViewChild(MatSort) sort: MatSort;

  //acctTypes = [];
  taxes = [];
  model = {
    'table_name': 'main_acct', 'acct_type_no': '0', 'main_acct_name': '', 'main_acct_name_en': '',
    'main_acct_number': '', 'def_tax_id': '0', 'comment': ''
  };

  Acct_No_Exist;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants, private queryList: QueryList,
    private dialogRef: MatDialogRef<MainAcctComponent>, @Inject(MAT_DIALOG_DATA) public dialog_data: any,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Acct_No_Exist').subscribe((res: string) => {
      this.Acct_No_Exist = res;
    });
  }

  ngOnInit() {
    console.log(this.dialog_data);
    this.model = {
      'table_name': 'main_acct', 'acct_type_no': this.dialog_data.acct_type_no, 'main_acct_name': '', 'main_acct_name_en': '',
      'main_acct_number': '', 'def_tax_id': '0', 'comment': ''
    };

    //////////////////////////// Get next main acct number ///////////////////////////        
    let query = "SELECT MAX(`main_acct_number`) as 'max_number' FROM `main_acct` WHERE `status` = 1 AND `acct_type_no` = " + this.dialog_data.acct_type_no;
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        let max_number = Number(data.data['list'][0].max_number);
        if (max_number > 0) // not first item
          this.model.main_acct_number = String(max_number + 1);
        else // first account in this type
        {
          this.model.main_acct_number = String(Number(this.dialog_data.acct_type_no) * 100 + 1);
        }
        //console.log(this.acctTypes);

      });

    ////////////////////////////// Get all taxes ///////////////////////////
    let query2 = this.queryList.all_tax_types;
    let obj2 = { cmd: 'getList', query: query2 };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.taxes = data.data['list'];
        //console.log(this.taxes);

      });

    ////////////////////////////// Get all main accts ///////////////////////////
    // let query3 = this.queryList.all_mainAcct;
    // let obj3 = {cmd: 'getList', query:query3};
    // //console.log(obj);

    // this.utils.invokeHttp(this.applicationConstants.generalFile, obj3)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     this.dp = data.data['list'];
    //     //console.log(this.dp);
    //     this.dataSource = new MatTableDataSource(this.dp);
    //     this.dataSource.sort = this.sort;

    //   });
  }

  add() {
    //alert("hi");
    //this.fileNameDialogRef = this.dialog.open(AddCountryPopComponent);

    //check if the main_acct_number exists:
    let acct_num_exist = false;
    let query = "SELECT `main_acct_number` FROM `main_acct` WHERE `status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        data.data['list'].forEach(element => {
          if (element.main_acct_number == this.model['main_acct_number']) {
            alert(this.Acct_No_Exist);
            acct_num_exist = true;
          }
        });

        if (!acct_num_exist) {
          let values = [];
          values.push(this.model);
          let obj = { cmd: 'add', values: values };
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              //this.ngOnInit();
              this.dialogRef.close(this.dialog_data);
            });
        }
      });

  }

  cancel() {
    this.dialogRef.close(this.dialog_data);
  }

}
